/**
 * A file's ORIGINAL page count, from `details.veritoneFile.pageCount`.
 *
 * In the state layer because both layers need it: the folder view draws it in
 * a column, and the Bates sequence spans each merged-document member by it.
 * It lived in `CaseFolders/helper.ts` and was imported from there — the first
 * time a state module had reached into a view helper, which also dragged in
 * moment, react-intl and `@cbsa-modules/universal` (a package CLAUDE.md marks
 * abandoned) behind it.
 *
 * `details` arrives as a parsed object or as a JSON string depending on the
 * source, which is why this does not just read the field.
 *
 * KEEP IT A LEAF. `projects/batesStamp` imports this, and `casemedia`
 * already imports plenty of `projects`, so the two folders are mutually
 * dependent at the folder level and only stay acyclic because this file
 * imports nothing. Giving either folder a barrel `index.ts`, or giving this
 * file an import, turns that into a real cycle.
 */
export const readFilePageCount = (details: unknown): number | null => {
  if (!details) {
    return null;
  }
  let obj: unknown = details;
  if (typeof obj === 'string') {
    try {
      obj = JSON.parse(obj);
    } catch {
      return null;
    }
  }
  if (typeof obj !== 'object' || obj === null) {
    return null;
  }
  const file = (obj as { veritoneFile?: unknown }).veritoneFile;
  if (typeof file !== 'object' || file === null) {
    return null;
  }
  const count = (file as { pageCount?: unknown }).pageCount;
  return typeof count === 'number' && Number.isFinite(count) && count > 0
    ? count
    : null;
};
